export const removeLinks = (text: string) => {
    return text.replace(/<a[^>]*>(.*?)<\/a>/gi, '$1');
};

export const formatProductNameWithNonBreakingSpaces = (value = '') => {
    const formattedValue = value.replace(/(\d)\s*x\s*(\d)/gi, '$1\u00A0x\u00A0$2');

    const map: Record<string, string> = {
        '0 ': '0\u00A0',
        '1 ': '1\u00A0',
        '2 ': '2\u00A0',
        '3 ': '3\u00A0',
        '4 ': '4\u00A0',
        '5 ': '5\u00A0',
        '6 ': '6\u00A0',
        '7 ': '7\u00A0',
        '8 ': '8\u00A0',
        '9 ': '9\u00A0',
        'ø ': 'ø\u00A0',
        ' s ': ' s\u00A0',
        ' z ': ' z\u00A0',
        ' v ': ' v\u00A0',
        ' ve ': ' ve\u00A0',
    };

    return formattedValue.replace(new RegExp(Object.keys(map).join('|'), 'g'), (match) => map[match]);
};
